import { render } from "./EntryPage.vue?vue&type=template&id=4579f436&scoped=true"
import script from "./EntryPage.vue?vue&type=script&lang=js"
export * from "./EntryPage.vue?vue&type=script&lang=js"

import "./EntryPage.vue?vue&type=style&index=0&id=4579f436&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4579f436"]])

export default __exports__